var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6773",
    "data-name": "\\uADF8\\uB8F9 6773",
    transform: "translate(11615 -2519)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4195",
    "data-name": "\\uC0AC\\uAC01\\uD615 4195",
    width: 48,
    height: 48,
    transform: "translate(-11615 2519)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6772",
    "data-name": "\\uADF8\\uB8F9 6772",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5647",
    "data-name": "\\uD328\\uC2A4 5647",
    d: "M15.182,31.591A1.591,1.591,0,1,1,13.591,30,1.591,1.591,0,0,1,15.182,31.591Z",
    transform: "translate(-11609.863 2523.227)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5648",
    "data-name": "\\uD328\\uC2A4 5648",
    d: "M31.682,31.591A1.591,1.591,0,1,1,30.091,30,1.591,1.591,0,0,1,31.682,31.591Z",
    transform: "translate(-11608.863 2523.227)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5649",
    "data-name": "\\uD328\\uC2A4 5649",
    d: "M1.5,1.5H7.864l4.264,21.3a3.182,3.182,0,0,0,3.182,2.561H30.773A3.182,3.182,0,0,0,33.955,22.8L36.5,9.455H9.455",
    transform: "translate(-11610.5 2521.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconBlack);
export default __webpack_public_path__ + "static/media/cart_icon_black.a2c56e955e23993baa348a906bab66e8.svg";
export { ForwardRef as ReactComponent };